import CreatableSearchSelect from "components/selects/CreatableSearchSelect";
import {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DropdownButton from "react-bootstrap/DropdownButton";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import ModalTasksSelect from "site-apps/maintenance/tasks/ModalTasksSelect";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";

const FormTabTaskSelection = ({item, setItem}) => {
    const tasks = item.tasks || [];
    const [showModalTasks, setShowModalTasks] = useState(false);

    useEffect(() => {
        return () => {
            unsubscribeEvent("tasks:modalselect:change", eventChangeTasks);
        };
    }, []);

    const handleAddTasks = () => {
        setShowModalTasks(true);
        subscribeEvent("tasks:modalselect:change", eventChangeTasks);
    };

    const eventChangeTasks = (e) => {
        const result_ = Array.isArray(e.detail) ? [...e.detail] : e.detail ? [e.detail] : [];
        const newTasks = (result_ || []).map((_item) => ({id: _item.id, name: _item.name}));
        setItem && setItem({...item, tasks: newTasks});
        unsubscribeEvent("tasks:modalselect:change", eventChangeTasks);
        setShowModalTasks(false);
    };

    const handleRemoveTask = (e) => {
        const idx = e.target?.dataset?.index !== undefined ? parseInt(e.target.dataset.index) : parseInt(e.currentTarget.dataset.index);
        setItem && setItem({...item, tasks: (item.tasks || []).filter((_, i) => i !== idx)});
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 text-end">
                    <button type="button" className="btn btn-outline-warning me-2" onClick={() => setItem && setItem({...item, tasks: []})} title="Limpiar">
                        <FontAwesomeIcon icon="broom" />
                    </button>
                    <DropdownButton
                        as={ButtonGroup}
                        id="dropdown-selector-tasks"
                        variant="outline-primary"
                        title={<FontAwesomeIcon icon="pen" />}>
                        <Dropdown.Item eventKey="a" onClick={handleAddTasks}>
                            <FontAwesomeIcon icon="wrench" /> Seleccionar tareas
                        </Dropdown.Item>
                    </DropdownButton>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th style={{width: "42px"}}></th>
                                <th>Tarea</th>
                                <th className="text-center" style={{width: "80px"}}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(tasks || []).map((t, index) => (
                                <tr key={index}>
                                    <td style={{verticalAlign: "middle"}} className="text-center">
                                        <FontAwesomeIcon icon="wrench" size="2xl" className="text-secondary" />
                                    </td>
                                    <td>{t.name}</td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-link text-body-tertiary"
                                            title="Borrar"
                                            data-index={index}
                                            onClick={handleRemoveTask}>
                                            <FontAwesomeIcon icon="trash" size="xl" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {showModalTasks ? (
                <ModalTasksSelect show={showModalTasks} setShow={setShowModalTasks} multiple={true} chosenIn={tasks} subtitle={document.title} />
            ) : (
                <></>
            )}
        </div>
    );
};

export default FormTabTaskSelection;
